import React from 'react'
import GoogleMap from './GoogleMap'
import styled from 'styled-components'
const googleMapURL = `https://maps.googleapis.com/maps/api/js?libraries=geometry&key=${process.env.REACT_APP_GOOGLE_MAP_WEBSITE_KEY}`

function SurgeryGoogleMap({ lat, lon }) {
  return (
    <Container>
      <GoogleMap
        googleMapURL={googleMapURL}
        loadingElement={<p>Loading Surgery Map...</p>}
        containerElement={<Container />}
        mapElement={<div style={gStyle} />}
        center={{ lat: Number(lat), lng: Number(lon) }}
      />
    </Container>
  )
}

export default SurgeryGoogleMap

const gStyle = {
  width: '100%',
  height: '325px',
  borderRadius: '13px'
}

const Container = styled.div`
&& 
{
  position: relative;
}
`
